export default "__VITE_ASSET__94b15a5c__"